import isNull from 'lodash/isNull'
import omitBy from 'lodash/omitBy'
import { Outlet } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'

import recurringRoutes from './recurringReportConfigurations'

import List from '@app/pages/reports/list'
import ReportsDrawer from '@app/pages/reports/reportsDrawer'
import Show from '@app/pages/reports/show'
import { useStore } from '@app/store'
import { loaderQuery } from '@graphql/client'
import { Report, Reports } from '@graphql/documents/report.graphql'
import type { ReportsQuery, ReportsQueryVariables } from '@graphql/queries'

const loadReports = async ({ request, params }) => {
  const url = new URL(request.url)
  const page = parseInt(url.searchParams.get('page'), 10) || 1
  const limit = parseInt(url.searchParams.get('limit'), 10) || null
  const { strategyId } = params

  const { addObjectPage } = useStore.getState()

  const variables: ReportsQueryVariables = { ...omitBy({ page, limit }, isNull), strategyId }

  const result = await loaderQuery<ReportsQuery, ReportsQueryVariables>(Reports, variables)
  const { collection = [], metadata } = result?.data?.reports || {}
  addObjectPage('report', collection, metadata)

  return result?.data
}

const loadReport = async ({ params }) => {
  const { reportId } = params
  const variables = { id: reportId }

  const resp = await loaderQuery(Report, variables)

  const report = resp?.data?.report

  return { report }
}

const routes: RouteObject = {
  path: 'reports',
  element: (
    <ReportsDrawer>
      <Outlet />
    </ReportsDrawer>
  ),
  loader: loadReports,
  children: [
    {
      index: true,
      element: <List />
    },
    recurringRoutes,
    {
      path: ':reportId',
      element: <Outlet />,
      children: [
        {
          index: true,
          loader: loadReport,
          element: <Show />
        }
      ]
    }
  ]
}

export default routes
